import * as actionTypes from './actionTypes';

const priceTypePayload = {
  loading: false,
  compareRebatePriceSerchResult: [],
  rebatePriceSerchResult: [],
  dataChangeTried: 0,
  errorMessage: '',
  successMessages: '',
};

const reducer = (state = priceTypePayload, action) => {
  switch (action.type) {
    case actionTypes.GET_PRICETYPE_DATA: {
      return {
        ...state,
        rebatePriceSerchResult: action.payload,
      };
    }
    case actionTypes.COMPARE_PRICE_TYPE_DATA:
      return { ...state, compareRebatePriceSerchResult: action.payload };
    case actionTypes.PRICE_TYPE_DATA_LOADING:
      return { ...state, loading: action.payload };
    case actionTypes.PRICE_TYPE_ERROR_MESSAGE:
      return { ...state, errorMessage: action.payload };
    case actionTypes.PRICE_TYPE_SUCCESS_MESSAGE:
      return { ...state, successMessages: action.payload };
    case actionTypes.PRICE_TYPE_DATA_CHANGE_TRIED:
      return { ...state, dataChangeTried: action.payload };
    case actionTypes.RESET_PRICETYPE_STORE:
      return { ...priceTypePayload };
    default:
      return state;
  }
};

export default reducer;
